'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withElementPortal = undefined;

var _ElementPortal = require('./ElementPortal');

var _ElementPortal2 = _interopRequireDefault(_ElementPortal);

var _withElementPortal = require('./withElementPortal');

var _withElementPortal2 = _interopRequireDefault(_withElementPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withElementPortal = _withElementPortal2.default;
exports.default = _ElementPortal2.default;